import * as React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";

import { authorize } from "reauthorize";

import { AppState, CustomerEditModel } from "../../model";
import { basePathSelector, customerSelector } from "../../selectors";
import { activateCustomer } from "../../actions";
import { ADMIN_ROLES } from "../../../../auth";

interface MergedProps {
    delete: () => void;
}

class ActivateButton extends React.Component<MergedProps> {
    public render() {
        return <div><Button icon="check" className="positive ui button" content="Activate" floated="left" onClick={() => this.props.delete()} /></div>;
    }
}

interface StateProps {
    id: any;
    basePath: string;
    model: CustomerEditModel;
}

interface DispatchProps {
    dispatchDelete: (id: any, basePath: string, model: CustomerEditModel) => void;
}

function mapStateToProps(state: AppState): StateProps {
    return {
        id: state.router.params.customerId,
        basePath: basePathSelector(state),
        model: customerSelector(state) as CustomerEditModel,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>): DispatchProps {
    return {
        dispatchDelete: (id) => dispatch<any>(activateCustomer(id))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        delete: () => propsFromDispatch.dispatchDelete(propsFromState.id, propsFromState.basePath, propsFromState.model)
    };
}

export default authorize([ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name])(
    connect(mapStateToProps, mapDispatchToProps, mergeProps)(ActivateButton));
